// @ts-nocheck
import useSWR from 'swr';

import { fetchModels } from 'src/store/api';

export default function useModels({ query, options = {}, config = { shouldFetch: true } }) {
  const { shouldFetch } = config;

  const url = `/core/v2/thinkalike_model?query=${JSON.stringify(query)}`;
  const { fields = '*', ...requestQuery } = query;
  const requestOptions = {
    headers: {
      'X-Fields': fields,
    },
    ...options,
  };

  return useSWR(
    shouldFetch ? { key: url, requestQuery, requestOptions } : null,
    ({ requestQuery: q, requestOptions: o }) => fetchModels(q, o),
    {
      revalidateIfStale: config.revalidateIfStale || false,
      revalidateOnMount: config.revalidateOnMount || false,
      revalidateOnFocus: config.revalidateOnFocus || false,
    }
  );
}
